import React, { useState, useEffect } from 'react';
import { useAuth } from '../App';
import OverviewPage from './OverviewPage';
import LiveViewPage from './LiveViewPage';
import PlaybackPage from './PlaybackPage';
import MapPage from './MapPage';
import { FleetPage, DriversPage, ReportsPage, GeofencePage, SettingsPage } from './OtherPages';
import AlertsPage from './AlertsPage';
import UsersPage from './UsersPage';
import { useNotifications, NotificationBell } from '../utils/useNotifications';

const NAV = [
  { section: 'Monitor' },
  { id: 'overview', label: 'Overview', icon: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' },
  { id: 'live', label: 'Live view', icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z' },
  { id: 'playback', label: 'Playback', icon: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z' },
  { id: 'map', label: 'GPS map', icon: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z' },
  { section: 'Fleet' },
  { id: 'fleet', label: 'Vehicles', icon: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z' },
  { id: 'drivers', label: 'Drivers', icon: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' },
  { id: 'geofence', label: 'Geofence', icon: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' },
  { section: 'Analytics' },
  { id: 'alerts', label: 'Alerts & evidence', icon: 'M12 2L1 21h22L12 2zm0 3.17L20.07 19H3.93L12 5.17zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z', badge: true },
  { id: 'reports', label: 'Reports', icon: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z' },
  { section: 'Admin' },
  { id: 'users', label: 'User management', icon: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' },
  { id: 'settings', label: 'Settings', icon: 'M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z' },
];

const PAGES = {
  overview: OverviewPage, live: LiveViewPage, playback: PlaybackPage,
  map: MapPage, fleet: FleetPage, drivers: DriversPage, alerts: AlertsPage,
  users: UsersPage, reports: ReportsPage, geofence: GeofencePage, settings: SettingsPage
};

const PAGE_LABELS = {
  overview: 'Dashboard overview', live: 'Live view', playback: 'Video playback',
  map: 'GPS map & tracking', fleet: 'Vehicles', drivers: 'Drivers',
  alerts: 'Alerts & evidence', users: 'User management', reports: 'Reports',
  geofence: 'Geofence', settings: 'Settings'
};

export default function Dashboard() {
  const { user, logout } = useAuth();
  const [page, setPage] = useState('overview');
  const { notifications, connected, unreadCount, markAllRead, clearAll, SEVERITY_COLOR } = useNotifications();
  const Page = PAGES[page] || OverviewPage;

  // Make auth available globally for map page API calls
  useEffect(() => { window.__mdvrAuth = user; }, [user]);

  const alertCount = notifications.filter(n => !n.read && n.severity === 'critical').length;

  return (
    <div style={{ display:'flex', height:'100vh', background:'#f4f6f9', fontFamily:'system-ui,sans-serif' }}>
      {/* Sidebar */}
      <div style={{ width:210, flexShrink:0, background:'white', borderRight:'0.5px solid #e8e8e8', display:'flex', flexDirection:'column' }}>
        <div style={{ padding:'14px 14px 12px', borderBottom:'0.5px solid #e8e8e8', display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:28, height:28, background:'#185FA5', borderRadius:6, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            <svg width="14" height="14" fill="white" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg>
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:500 }}>MDVR System</div>
            <div style={{ fontSize:10, color:'#999' }}>CMSV6 Connected</div>
          </div>
        </div>

        <div style={{ flex:1, overflowY:'auto', padding:'8px 6px' }}>
          {NAV.map((item, i) => {
            if (item.section) return (
              <div key={i} style={{ fontSize:10, color:'#bbb', padding:'10px 8px 4px', letterSpacing:'.05em', fontWeight:500 }}>
                {item.section.toUpperCase()}
              </div>
            );
            const active = page === item.id;
            return (
              <div key={item.id} onClick={() => setPage(item.id)}
                style={{ display:'flex', alignItems:'center', gap:8, padding:'7px 10px', borderRadius:8, cursor:'pointer', fontSize:12, color:active?'#0C447C':'#555', background:active?'#E6F1FB':'transparent', marginBottom:1, fontWeight:active?500:400, transition:'background .12s' }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill={active?'#185FA5':'#888'} style={{ flexShrink:0 }}><path d={item.icon}/></svg>
                <span style={{ flex:1 }}>{item.label}</span>
                {item.badge && alertCount > 0 && (
                  <span style={{ background:'#E24B4A', color:'white', fontSize:9, fontWeight:500, padding:'1px 5px', borderRadius:8 }}>{alertCount}</span>
                )}
              </div>
            );
          })}
        </div>

        <div style={{ padding:'12px 14px', borderTop:'0.5px solid #e8e8e8' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:10 }}>
            <div style={{ width:28, height:28, borderRadius:'50%', background:'#E6F1FB', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:500, color:'#185FA5' }}>
              {user.account?.substring(0,2).toUpperCase()}
            </div>
            <div>
              <div style={{ fontSize:12, fontWeight:500 }}>{user.account}</div>
              <div style={{ fontSize:10, color:'#999' }}>Admin</div>
            </div>
          </div>
          <button onClick={logout} style={{ width:'100%', padding:'6px', background:'transparent', border:'0.5px solid #ddd', borderRadius:6, fontSize:11, color:'#666', cursor:'pointer' }}>
            Sign out
          </button>
        </div>
      </div>

      {/* Main content */}
      <div style={{ flex:1, overflow:'hidden', display:'flex', flexDirection:'column' }}>
        {/* Top bar */}
        <div style={{ background:'white', borderBottom:'0.5px solid #e8e8e8', padding:'0 20px', height:48, display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
          <div style={{ fontSize:14, fontWeight:500 }}>{PAGE_LABELS[page] || page}</div>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            {/* Live status */}
            <div style={{ display:'flex', alignItems:'center', gap:5 }}>
              <span style={{ width:6, height:6, borderRadius:'50%', background:'#4CAF50', display:'inline-block' }} />
              <span style={{ fontSize:11, color:'#4CAF50' }}>CMSV6 Live</span>
            </div>
            {/* WebSocket status */}
            <div style={{ display:'flex', alignItems:'center', gap:5 }}>
              <span style={{ width:6, height:6, borderRadius:'50%', background: connected?'#185FA5':'#E24B4A', display:'inline-block' }} />
              <span style={{ fontSize:11, color:'#888' }}>{connected ? 'Alerts on' : 'Reconnecting'}</span>
            </div>
            {/* Notification bell */}
            <NotificationBell
              notifications={notifications}
              unreadCount={unreadCount}
              connected={connected}
              markAllRead={markAllRead}
              clearAll={clearAll}
              SEVERITY_COLOR={SEVERITY_COLOR}
            />
          </div>
        </div>

        {/* Page content — overflowY:auto lets non-full-height pages scroll naturally */}
        <div style={{ flex:1, minHeight:0, padding:20, overflowY:'auto' }}>
          <Page />
        </div>
      </div>
    </div>
  );
}
